import React from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import CustomModal from "../../common/CustomModal";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  destructive = false,
  loading = false,
  onCancel,
  onConfirm,
}) => (
  <CustomModal
    show={open}
    onHide={onCancel}
    title={
      <div className="flex items-center gap-3">
        <span
          className={`flex h-9 w-9 items-center justify-center rounded-full ${
            destructive ? "bg-red-50 text-red-600" : "bg-amber-50 text-amber-600"
          }`}
        >
          <AlertTriangle className="h-5 w-5" />
        </span>
        <span>{title}</span>
      </div>
    }
    width="w-full max-w-md"
    footer={
      <>
        <button
          type="button"
          disabled={loading}
          onClick={onCancel}
          className="rounded-md border border-cardborder bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          disabled={loading}
          onClick={onConfirm}
          className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium text-white disabled:opacity-50 ${
            destructive ? "bg-red-600 hover:bg-red-700" : "bg-brand hover:bg-brand/90"
          }`}
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          {confirmLabel}
        </button>
      </>
    }
  >
    <div className="w-full px-1 pb-2 text-sm text-gray-600">{description}</div>
  </CustomModal>
);
